import { Component, OnInit } from "@angular/core";
import { constants } from "../../../utils/constants";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { IErrorAlert } from "../../../interfaces/error.interface";
import { Router } from "@angular/router";
import { RequestService } from "../../../services/request.service";
import { IRequestType, RequestModel } from "../../../models/request.model";

import helpers from "../../../utils/helpers";

import Swal from "sweetalert2";
import { AuthService } from "../../../services/auth.service";

@Component({
  selector: "app-new-request",
  templateUrl: "./new-request.component.html",
  styleUrls: ["./new-request.component.css"],
})
export class NewRequestComponent implements OnInit {
  constants: any = constants;
  helpers = helpers;
  requestTypes = constants.rules.requestTypes;
  title: string = "Adjuntar planilla de pagos .txt";
  icon: string = "assets/images/requests/icn-upgrade.png";
  form: FormGroup;
  file: File = null;
  error: IErrorAlert;

  loading = false;
  isOver = false;

  constructor(
    private _fb: FormBuilder,
    private _router: Router,
    public _request: RequestService,
    public _auth: AuthService
  ) {}

  ngOnInit(): void {
    this.form = this._fb.group({
      type: [this._request.shouldResetFile ? "" : this._request.type, Validators.required],
    });
    if (!this._request.shouldResetFile) {
      this.file = this._request.file;
      this._request.shouldResetFile = true;
    }
    if(this.file != null){
      this.onFileSelected(this.file);
    }
    
  }

  canContinue() {
    return this.form.valid && this.file;
  }

  continue() {
    this.loading = true;
    this._request
      .processFile(this.file, this.form.get("type").value, this._auth.user)
      .then((request: RequestModel) => {
        this._router.navigate(["/pages/confirm-request"]);
      })
      .catch((err) => {

        err?.type
          ? (this.error = { ...err, width: "auto" }) //Service error
          : this.showFileErrorAlert(); //File format error
        this.reset();
      })
      .finally(() => (this.loading = false));
  }

  onFileSelected(file: File) {
    if (!file) return;
    this.reset();
    if (this.validateFile(file)) {
      this.error = null;
      this.title = "Se ha adjuntado correctamente el documento";
      this.icon = "assets/images/requests/icn-check.png";
      this.file = file;
    }
  }

  reset() {
    this.icon = "assets/images/requests/icn-upgrade.png";
    this.title = "Adjuntar planilla de pagos .txt";
    this.file = null;
  }

  showFileErrorAlert() {
    Swal.fire({
      showClass: {
        popup: "animated fadeIn fast",
      },
      hideClass: {
        popup: "animated fadeOut fast",
      },
      html:
        "<p>Ha ocurrido un error, por favor revise el archivo cargado, e intente subir uno nuevo.</p>",
      icon: "warning",
      showCloseButton: true,
      confirmButtonText: "Aceptar",
      customClass: {
        confirmButton: "confirm-button-class",
        closeButton: "close-button-class",
        icon: "warning-icon-class",
      },
    });
  }

  

  getFilePath() {
    let filePath, fileName;
    switch (+this.form.get("type").value) {
      case 10:
        filePath = "macro_rrbb.xlsm";
        fileName = "Plantilla carga - regularización de remuneraciones brutas.xls"
        break;

      case 11:
        filePath = "macro_pago_haberes_cts.xls";
        fileName = "Formulario_Depositos_en_Cuenta_2003_final_v5.xls"
        break;

      case 12:
        filePath = "macro_pago_haberes_cts.xls";
        fileName = "Formulario_Depositos_en_Cuenta_2003_final_v5.xls"
        break;
    }
    return {
      path: "assets/requests/" + filePath,
      name: fileName,
    }
  }

  //Validations
  private validateFile(file: File): boolean {
    if (helpers.oversizeFile(file, 3)) {
      this.error = constants.alerts.requests.oversizeFile;
      return false;
    }
    if (!helpers.isTxt(file)) {
      this.error = constants.alerts.requests.invalidExtension;
      return false;
    }
    return true;
  }

  showModal() {
    Swal.fire({
      html: this.getModalHTML(),
      showCloseButton: true,
      showConfirmButton: false,
      showClass: {
        popup: "animated fadeIn fast",
      },
      hideClass: {
        popup: "animated fadeOut fast",
      },
      customClass: {
        popup: "swal2-popup-class",
        content: "swal2-content-padding",
        closeButton: "close-button-class",
      },
    });
  }

  getModalHTML() {
    return (
      "<h3 class='text-left primary'>Ejemplo composición del nombre .txt de " +
      this.getTypeName() +
      "</h3>" +
      "<hr/><div class='row'>" +
      "<div class='col-md-6'>" +
      "<img src="+ this.getImageOfNames('me') +">" +
      "</div>" +
      "<div class='col-md-6'>" +
      "<img src="+ this.getImageOfNames('mn') +">" +
      "</div>" +
      "</div>"
    );
  }

  getTypeName() {
    switch (+this.form.get("type").value) {
      case 10:
        return "Actualización de Remuneraciones";
      case 11:
        return "Pago Cuenta CTS";
      case 12:
        return "Pago de Haberes";
    }
  }

  getImageOfNames(currency: 'me' | 'mn') {
    let fileName;
    switch (+this.form.get("type").value) {
      case 10:
        fileName = "rrbb-"+ currency + ".png";
        break;

      case 11:
        fileName = "cts-"+ currency + ".png";
        break;

      case 12:
        fileName = "pagohaberes-"+ currency + ".png";
        break;
    }
    return "assets/requests/" + fileName;
  }


}
